export const getParameterByName = (name, url) => {
  const regex = new RegExp(
    `[?&]${name.replace(/[[\]]/g, '\\$&')}(=([^&#]*)|&|#|$)`,
  );
  const results = regex.exec(url);
  return results && results.length === 3 && results[2]
    ? decodeURIComponent(results[2].replace(/\+/g, ' '))
    : null;
};
